import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useMemo, useState } from 'react';

import type { DonutChartDataTypes } from '../DonutChart.types';
import useStyles from './DonutChartLegend.styles';

const DonutChartLegend = ({
  data,
  colors,
  numFormatter,
  visibleItems,
  onLegendItemClick
}: {
  data: DonutChartDataTypes[];
  colors: string[];
  numFormatter: Intl.NumberFormat;
  visibleItems: Set<string>;
  onLegendItemClick: (itemName: string) => void;
}) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const windowHeightOverEqual1280 = useMemo(() => {
    return windowHeight >= 1280;
  }, [windowHeight]);
  const { classes } = useStyles({ windowHeightOverEqual1280 });

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Stack
      className={classes.donutChartLegend}
      spacing={windowHeightOverEqual1280 ? 0.5 : 0.1}
    >
      {data?.map((item, index) => {
        const isVisible = visibleItems.has(item.name);
        return (
          <Box
            key={item.name}
            className={classes.donutChartLegendItemContainer}
            sx={{ opacity: isVisible ? 1 : 0.5 }}
            onClick={() => onLegendItemClick(item.name)}
          >
            <Box className={classes.donutChartLegendItem}>
              <Box
                className={classes.donutChartLegendItemColorSwatch}
                sx={{ backgroundColor: colors[index] }}
              />
              <Typography className={classes.donutChartLegendItemName}>
                {item.name}
              </Typography>
            </Box>
            <Typography className={classes.donutChartLegendItemCount}>
              {numFormatter.format(item.count ?? 0)}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default DonutChartLegend;
